import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { Box, Container } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';

const Proposta: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [pdfBase64, setPdfBase64] = useState('');
  const [Loading, setLoading] = useState(true);
  const [dots, setDots] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    console.log('id: ', id);
    handleFormSubmit();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => (prev.length < 3 ? prev + '.' : ''));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  const handleFormSubmit = async () => {
    setPdfBase64('');
    const urlBase = process.env.REACT_APP_OG_API_URL;

    try {
      const response = await axios.get(
        `${urlBase}/generate/proposta?cd_associado=${id}`,
      );
      const dados = response.data;
      if (dados) {
        console.log('dados: ', dados);
        setPdfBase64(dados.proposta);
        setLoading(false);
      }
    } catch (error: any) {
      console.error('Erro ao buscar Proposta:', error);
      alert('Erro ao buscar Proposta ' + error.response.data.message);
      /* navigate('/'); */
    }
  };

  return (
    <Container>
      {!Loading ? (
        <div style={{ minHeight: '100vh' }}>
          <embed
            src={`data:application/pdf;base64,${pdfBase64}`}
            type="application/pdf"
            width="100%"
            height="900px"
            style={{ marginTop: '100px', border: '1px solid #ccc' }}
          />
        </div>
      ) : (
        <div style={{ marginTop: '150px', minHeight: '40vh' }}>
          <h1 style={{ textAlign: 'center', fontSize: '36px' }}>
            Carregando{dots}
          </h1>
        </div>
      )}
    </Container>
  );
};

export default Proposta;
